import { ArrangementFilter } from '../types/arrangement.filter';

export const ArrangementFilterParamsMap: Record<
  keyof ArrangementFilter,
  string
> = {
  userDelete: 'filter[userDelete]',
  includeCreatedByActor: 'filter[includeCreatedByActor]',
  withPublications: 'filter[withPublications]',
  methodCode: 'filter[method]',
  type: 'filter[type]',
  cpi: 'filter[cpi]',
  code: 'filter[code]',
  arrangeable: 'filter[arrangeable]',
  method: 'filter[method]',
  methodSlug: 'filter[methodSlug]',
  cluster: 'filter[cluster]',
  methodEdition: 'filter[methodEdition]',
  learningLevel: 'filter[learningLevel]',
  schoolYear: 'filter[schoolYear]',
  description: 'filter[description]',
};
